import React, { useEffect, useRef, useState } from "react";
import Layout from "../pages/Layout";
import AddProductModal from "../components/AddProduct";
import HomeIcon from "../assets/icons/home_icon";
import DateIcon from "../assets/icons/calender_icon"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../config";
import axios from "axios";
import { toast } from "react-toastify";
import MeasurementModal from "../components/Measurement";
import ClipLoader from "react-spinners/ClipLoader";
import EditIcon from "../images/edit_icon";
import AddStyleModal from "../components/AddStyle";

import DeleteIcon from "../images/delete_icon";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"; // British format


registerLocale("en-GB", enGB);



const OrderPage = ({ }) => {
    const { customer_id } = useParams();
    const [shippingDetails, setShippingDetails] = useState({
        address: "",
        phoneNumber: "",
        shippingMethod: "",
    });
    const navigate = useNavigate();
    const [isSending, setIsSending] = useState(false);
    const [isQuoteCreated, setIsQuoteCreated] = useState(false);
    const [orderId, setOrderId] = useState("");
    const [measurementModalOpen, setMeasurementModalOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedStyle, setSelectedStyle] = useState("");
    const [styleModalOpen, setStyleModalOpen] = useState(false);
    const [customerId, setCustomerId] = useState("")
    const [orderNo, setOrderNo] = useState("");
    const [isDisable, setIsSaveDisable] = useState(false);
    const [selectedTeamMember, setSelectedTeamMember] = useState("");
    const location = useLocation();
    const { state } = location || {};
    const [quoteId, setQuoteId] = useState("");
    const [styleToDuplicate, setStyleToDuplicate] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [loadingCustomer, setLoadingCustomer] = useState(true);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [jacketMeasurements, setJacketMeasurements] = useState(null);
    const [totalPrice, setTotalPrice] = useState(0)
    const [discount, setDiscount] = useState(0)

    const [selectedImages, setSelectedImages] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(null);
    const [uploadedImages, setUploadedImages] = useState([]);

    const [orderStatus, setOrderStatus] = useState("To Place");
    const [shippedDate, setShippedDate] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState("");
    const [currentCustomerId,setCurrentCustomerId]= useState(null)


    const [error, setError] = useState('');
    const [deliveryDate, setDeliveryDate] = useState(() => {
        if (state?.deliveryDate) return new Date(state.deliveryDate);

        const today = new Date();
        const oneMonthLater = new Date(today.setMonth(today.getMonth() + 1));
        return oneMonthLater;
    });

    const [weddingDate, setWeddingDate] = useState(
        state?.weddingDate ? new Date(state.weddingDate) : null
    );

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newProduct, setNewProduct] = useState({
        style: "",
        quantity: 1,
        fabric: "",
        lining: "",
        groomsman: false,
        price: "",
        remarks: "",
        order_no: orderNo
    });

    const [productsInOrder, setProductsInOrder] = useState([]);
    // const location = useLocation();
    const { quote_id, quoteNo, } = location.state || {};
    useEffect(() => {
        if (quote_id) {
            setIsQuoteCreated(true);
        }
    }, [quote_id]);

    // useEffect(() => {
    //     fetchProducts();
    // }, [uploadedImages]);



    const handleStyleModalClose = () => {
        setStyleModalOpen(false);
        setSelectedStyle("");
    };

    // console.log(products,"products")

    const handleSaveProduct = (product) => {
        if (!product || !product._id) return; // Skip if product is invalid

        setProducts((prevProducts) => {
            const existingIndex = prevProducts.findIndex(
                (p) => p._id === product._id
            );
            if (existingIndex >= 0) {
                const updatedProducts = [...prevProducts];
                updatedProducts[existingIndex] = { ...product };
                return updatedProducts;
            }
            return [...prevProducts, product];
        });

        handleModalClose();
    };


    // const displayProducts = products.flatMap(product => {
    //     console.log(product,"product")
    //   if (product.description?.toLowerCase() === 'suit' && product.components) {
    //     // Only map over non-null components (pant or jacket)
    //     return Object.entries(product.components)
    //       .filter(([_, component]) => component) // skip null/undefined components
    //       .map(([key, component]) => ({
    //         ...component,
    //         _id: `${product._id}-${component?.description}`, // unique key
    //         customerInfo: product.customerInfo || customer,
    //         customer_id: product.customer_id,
    //         quote_id: product.quote_id,
    //         parentSuitId: product._id
    //       }));
    //   }

    //   // Not a suit or no components, return as-is
    //   return [{
    //     ...product,
    //     customerInfo: product.customerInfo || customer
    //   }];
    // });

    const displayProducts = products.flatMap(product => {

        if (product.description?.toLowerCase() === 'suit' && product.components) {

            return Object.entries(product.components)
                .filter(([key, component]) => component !== null)
                .map(([key, component]) => ({

                    ...product,
                    ...component,


                    _id: `${product._id}-${key}`,
                    parentSuitId: product._id,
                    customerInfo: product.customerInfo || customer,
                    customer_id: product.customer_id,
                    quote_id: product.quote_id,
                }));
        }

        // For all other products (Shirt, Vest, etc.), return them as they are
        return [{
            ...product,
            customerInfo: product.customerInfo || customer
        }];
    });

    const fetchProducts = async () => {
        setLoadingProducts(true);
        try {
            if (quote_id) {
                const response = await axios.get(`${config.BASE_URL}/api/v1/products/by-quote/${quote_id}`);

                // console.log(response.data.productDetail);
               
                setProducts(response.data.productDetail);

            }
        }
        catch (error) {
            console.error("Error fetching products by quote ID:", error);
        } finally {
            setLoadingProducts(false);
        }
    };


    useEffect(() => {
        if (!quote_id) return;
        fetchProducts();
    }, [quoteId]);

    useEffect(() => {
        const fetchOrderByQuote = async () => {

            try {
                const response = await axios.get(`${config.BASE_URL}/api/v1/orders/by-quote/${quote_id}`);
                if (response.status == 200) {
                    navigate(`/edit-order/${response?.data?.order?._id}`)
                }

            } catch (error) {
                console.log(error, "error")
            }

        }

        fetchOrderByQuote();
    }, []);


    const handleDuplicateStyleOpen = (style) => {
        setStyleToDuplicate(style);
        // setDuplicateStyleModalOpen(true);
    };


   

//     const handleDeleteProduct = async (productId) => {
//     // 1. Extract the Real ID if it has a suffix (e.g., "12345-jacket" -> "12345")
//     const realId = String(productId).split('-')[0];

//     const confirmDelete = window.confirm("Are you sure you want to delete this product?");
//     if (!confirmDelete) return;

//     try {
//       // Use realId for the API call
//       const response = await axios.delete(`${config.BASE_URL}/api/v1/deleteProduct/${realId}`);

//       if (response.status === 200) {
//         toast.success("Product deleted successfully.");

//         // 2. Filter using the Real ID
//         setProducts((prevProducts) =>
//           prevProducts.filter((product) => String(product._id) !== realId)
//         );
//       } else {
//         toast.error("Failed to delete the product. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error deleting product:", error);
//       toast.error("An error occurred while deleting the product.");
//     }
//   };

 const handleDeleteProduct = async (productId) => {
      // 1. Extract the Real ID if it has a suffix (e.g., "12345-jacket" -> "12345")
      const realId = String(productId);
  
      const confirmDelete = window.confirm("Are you sure you want to delete this product?");
      if (!confirmDelete) return;
  
      try {
        const response = await axios.delete(`${config.BASE_URL}/api/v1/deleteProduct/${realId}`);
         
        if (response.status === 200) {
          toast.success("Product deleted successfully.");
         if (response?.data?.product?.description == "Suit") {
         const updatedProductData =response?.data?.product
         
          setProducts((prevProducts) =>
            prevProducts.map((p) => {
                    
                    if (p._id === updatedProductData._id) {
                        if (p.description== "Suit") {
                          return { ...p, components: updatedProductData.components };  
                        }   
                    }
                    return p;
                })
          );
         }else{
           setProducts((prevProducts) =>
            prevProducts.filter((product) => String(product._id) !== realId)
          );
         }
         
        } else {
          toast.error("Failed to delete the product. Please try again.");
        }
      } catch (error) {
        console.error("Error deleting product:", error);
        toast.error("An error occurred while deleting the product.");
      }
    };

    

    
    const handleRemoveImage = async (imageUrl, index, productId) => {
    // 1. Add a confirmation to prevent accidental deletes
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this image?"
    );
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${config.BASE_URL}/api/v1/deleteImage/${productId}`,
        {
          data: { imageUrl: imageUrl }, // <--- Body goes here for DELETE requests
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Image removed successfully");

        // Get updated product data from backend response
        const updatedProductData = response.data.product;

        // Update local state immediately
        setProducts((prevProducts) =>
          prevProducts.map((p) => {
            // Check for matching ID
            if (p._id === updatedProductData._id) {
              // If it's a Suit, update the components object (where images live for suits)
              if (p.description === "Suit") {
                return { ...p, components: updatedProductData.components };
              }
              // For other products, update the main images array
              return { ...p, images: updatedProductData.images };
            }
            return p;
          })
        );
      } else {
        toast.error("Failed to delete the image");
      }
    } catch (error) {
      console.error("Error while deleting the image:", error);
      toast.error(error.response?.data?.message || "Error removing image");
    }
  };
    const handleStyleModalOpen = (style, productId, customerId) => {

        setSelectedStyle(style);
        setProductsInOrder(productId);
        // setCustomerId(customerId);
        setCurrentCustomerId(customerId)
        setStyleModalOpen(true);
    };

    const handleMeasurementModalClose = () => {
        setMeasurementModalOpen(false)
    }

    const handleMeasurementModalOpen = (product) => {
        setSelectedStyle(product.description);
        setProductsInOrder(product._id);
        // setCustomerId(customer_id);
        
        setCustomerId(product.cusomertInfo?._id ||  customer?._id);

        // Naya logic: check karo agar yeh suit ka part hai (Shirt/Vest)
        const isSuitComponent = !!product.parentSuitId;
        const style = product.description.toLowerCase();

        if (isSuitComponent && (style === 'shirt' || style === 'vest')) {
            // Original 'products' state se parent suit ko dhoondo
            const parentSuit = products.find(p => p._id === product.parentSuitId);

            if (parentSuit && parentSuit.measurements) {
                // Jacket (parent suit) ke measurements ko state mein save karo
                setJacketMeasurements(parentSuit.measurements);
            } else {
                setJacketMeasurements(null); // Data nahi mila
            }
        } else {
            setJacketMeasurements(null); // Normal product, copy nahi karna
        }

        setMeasurementModalOpen(true);
    };

    const handleEditProduct = async (product) => {
        setNewProduct(product);
        setIsModalOpen(true);
    };



    const handleButtonClick = (productId) => {
        if (fileInputRefs.current[productId]) {
            fileInputRefs.current[productId].click();
        } else {
            console.log(`File input for product ${productId} is not available yet`);
        }
    };

    const fileInputRefs = useRef({});


    const handleImageChange = async (e, productId) => {

        const files = Array.from(e.target.files);
        setSelectedImages(files);

        const formData = new FormData();

        files.forEach((file) => {
            formData.append('images', file);
        });

        try {
            const response = await axios.put(
                `${config.BASE_URL}/api/v1/updateImages/${productId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    onUploadProgress: (progressEvent) => {
                        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(progress);
                    }

                }
            );
             if(response.status === 200) {
            const updatedProductData = response.data.product; 
            
            setProducts((prevProducts) => 
                prevProducts.map((p) => {
                    
                    if (p._id === updatedProductData._id) {
                        if (p.description== "Suit") {
                          return { ...p, components: updatedProductData.components };  
                        }
                        return { ...p, images: updatedProductData.images };
                    }
                    return p;
                })
            );
            setUploadedImages(updatedProductData.images); // Keep this if you use it elsewhere
        }

            setUploadProgress(null);

        } catch (error) {
            console.error('Error updating product images:', error);
        }
    };



    const queryParams = new URLSearchParams(location.search);

    const handleAddProductClick = () => {
        setIsModalOpen(true);
        setNewProduct((prev) => ({ order_no: orderNo }));
    };


    const fetchCustomerDetails = async () => {
        try {
            const response = await fetch(`${config.BASE_URL}/api/v1/detail/${customer_id}`);
            if (!response.ok) {
                throw new Error('Failed to fetch customer details');
            }
            const data = await response.json();
            setCustomer(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoadingCustomer(false);
        }
    };

    useEffect(() => {
        fetchCustomerDetails();
    }, [customer_id]);

    useEffect(() => {

        const subtotal = products.reduce((accumulator, currentProduct) => {
            const price = parseFloat(currentProduct.price) || 0;
            const quantity = parseInt(currentProduct.quantity) || 1;
            return accumulator + (price * quantity);
        }, 0);

        const numericDiscount = parseFloat(discount) || 0;
        const finalTotal = subtotal - numericDiscount;

        setTotalPrice(Math.max(0, finalTotal));

    }, [products, discount]);

    const fetchQuoteDetails = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/v1/quoteDetail/${quote_id}`);

            const data = response.data?.quoteDtail ?? response.data?.quoteDetail ?? {};
            const productData = response.data?.productDetail ?? [];
              setCustomerId(data?.customer_id?._id)
            setTotalPrice(data?.totalPrice)
            setDiscount(data.discount)
            if (data?.weddingDate) {
                setWeddingDate(new Date(data.weddingDate));
            }

           
        } catch (err) {
            console.error("Error fetching quote details:", err);
        }
    };

    useEffect(() => {
        fetchQuoteDetails()
    }, [])




    const handleModalClose = () => {
        setIsModalOpen(false);
        setNewProduct({
            style: "",
            quantity: 1,
            fabric: "",
            lining: "",
            groomsman: false,
            price: "",
            remarks: "",
        });
    };
    const productOptions = [
        { id: 1, style: "Suit" },
        { id: 2, style: "Jacket" },
        { id: 3, style: "Shirt" },
        { id: 4, style: "Pant" },
        { id: 5, style: "Tuxedo" },
        { id: 6, style: "Vest" },
        { id: 7, style: "Overcoat" },
        { id: 8, style: "Accessories" },
    ];
    const generateRandomOrderNo = () => {
        const randomNumber = Math.floor(Math.random() * 100000) + 1000;
        return `AR${randomNumber}`;
    };


    const checkOrderNoExistence = async (generatedOrderNo) => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/v1/checkOrderNo`, {
                params: { orderNo: generatedOrderNo }
            });
            return response.data.exists;
        } catch (error) {
            console.error("Error checking quote number existence:", error);
            return false;
        }
    };


    const generateUniqueOrderNo = async () => {
        let isUnique = false;
        let newOrderNo = "";

        while (!isUnique) {
            newOrderNo = generateRandomOrderNo();
            isUnique = !(await checkOrderNoExistence(newOrderNo));
        }

        setOrderNo(newOrderNo);
    };

    useEffect(() => {
        generateUniqueOrderNo();
    }, []);

    const [buttonLoading,setButtonLoading]= useState(false)

    const handleSaveOrder = async () => {
        // const deliveryDate = document.getElementById('deliveryDate').value;
        // const weddingDate = document.getElementById('weddingDate').value;
        setButtonLoading(true)

        const deliveryDateISO = deliveryDate ? deliveryDate.toISOString().split("T")[0] : "";
        const weddingDateISO = weddingDate ? weddingDate.toISOString().split("T")[0] : "";
        const handleStyleModalOpen = (style, productId, customerId) => {

            setSelectedStyle(style);
            setProductsInOrder(productId);
            setCustomerId(customerId);
            setStyleModalOpen(true);
        };

        const productIds = products.map(p => p._id);
        const orderData = {
            customer_id,
            order_no: orderNo,
            price: totalPrice,
            delivery_date: deliveryDateISO,
            wedding_date: weddingDateISO,
            team_member: selectedTeamMember,
            product_ids: productIds,
            quote_id: quote_id,
            status: document.getElementById('orderStatus').value,
            location: selectedLocation,
            order_date: new Date().toISOString().split("T")[0],
        };


        // 🚨 Validate date ranges
        const isValidDate = (dateStr) => {
            if (!dateStr) return true; // Allow empty
            const date = new Date(dateStr);
            const year = date.getFullYear();
            return !isNaN(date.getTime()) && year >= 2000 && year <= 2026;
        };

        if (!isValidDate(deliveryDate)) {
            toast.error("Invalid delivery date. Year must be between 2000 and 2026.");
            return;
        }

        if (!isValidDate(weddingDate)) {
            toast.error("Invalid wedding date. Year must be between 2000 and 2026.");
            return;
        }

        try {
            const response = await axios.post(`${config.BASE_URL}/api/v1/addOrder`, orderData);
            if (response.status === 201) {
                const orderIdNew = response.data.data._id;
                const res = await axios.patch(`${config.BASE_URL}/api/v1/quote/update-discount/${quote_id}`, { totalPrice, discount,weddingDate:weddingDateISO })
                setOrderId(response.data._id);
                toast.success("Order added successfully!");
                setButtonLoading(false);
                setIsSaveDisable(true);
                // setTimeout(() => {
                //     window.location.reload();
                // }, 3000);
                navigate(`/edit-order/${orderIdNew}`)
            } else {
                toast.error("Failed to add order. Please try again.");
                setButtonLoading(false)
            }
        } catch (error) {
            console.error("Error adding order:", error);
            toast.error(error?.response?.data?.message || "An error occurred while adding the order.");
            setButtonLoading(false)
        }
    };


    function formatPureDate(date) {
        if (!(date instanceof Date)) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`; // "2025-10-22"
    }

    return (
        <Layout>
            <div className="order-page">
                <header className="header">
                    <h1>New Order</h1>
                    <p><HomeIcon /> / Orders / New Order</p>
                </header>

                <div className="customer_details_new_order layout_outer_shadow">
                    <div className="left">
                        <div class="form-group row">
                            <label class="field_label">Customer Name</label>
                            <div class="field_value">{customer?.customer_name}</div>
                        </div>
                        <div class="form-group row">
                            <label class="field_label">Order No</label>
                            <div class="field_value">{orderNo}</div>
                        </div>
                        <div class="form-group row">
                            <label class="field_label">Order Date</label>
                            <div class="field_value">{new Date().toISOString().split("T")[0]}</div>
                        </div>
                        <div class="form-group row">
                            <label class="field_label">Order price</label>
                            <div class="field_value">{totalPrice}</div>
                        </div>



                        <div className="form-group row">
                            <label htmlFor="teamMember" className="field_label">Team Member</label>
                            <div className="field_value">
                                <select
                                    id="teamMember"
                                    value={selectedTeamMember}
                                    onChange={(e) => setSelectedTeamMember(e.target.value)}
                                    className="team-member-select"
                                >
                                    <option value="" disabled>Select Team Member</option>
                                    <option value="Ajay">Ajay</option>
                                    <option value="Roshni">Roshni</option>
                                    <option value="Ajay/indigo">Ajay/indigo</option>
                                    <option value="Ajay/Raghav">Ajay/Raghav</option>
                                    <option value="Roshni/indigo">Roshni/indigo</option>
                                    <option value="Roshni/raghav">Roshni/raghav</option>
                                    <option value="Indigo">Indigo</option>
                                    <option value="Raghav">Raghav</option>
                                    <option value="Raghav/indigo">Raghav/indigo</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div className="right">
                        <div className="form-group row">
                            <label htmlFor="deliveryDate" className="field_label"><DateIcon />Delivery Date</label>
                            <div className="field_value">
                                <ReactDatePicker
                                    id="deliveryDate"
                                    selected={deliveryDate}
                                    onChange={(date) => setDeliveryDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Select delivery date"
                                    className="date-picker"
                                    locale="en-GB"
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="weddingDate" className="field_label"><DateIcon />Wedding Date</label>
                            <div className="field_value">
                                <ReactDatePicker
                                    id="weddingDate"
                                    selected={weddingDate}
                                    onChange={(date) => setWeddingDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Select wedding date"
                                    className="date-picker"
                                    locale="en-GB"
                                />
                            </div>
                        </div>




                        <div className="form-group row">
                            <label htmlFor="orderStatus" className="field_label">Order Status</label>
                            <div className="field_value">
                                <select
                                    id="orderStatus"
                                    value={orderStatus}
                                    onChange={(e) => setOrderStatus(e.target.value)}
                                >
                                    <option value="To Place">To Place</option>
                                    <option value="Production">Production</option>
                                    <option value="Received">Received</option>
                                    <option value="Delivered">Delivered</option>
                                    <option value="Shipped">Shipped</option>
                                </select>
                            </div>
                        </div>

                        {orderStatus === "Shipped" && (
                            <div className="form-group row" style={{ marginTop: "10px" }}>
                                <label htmlFor="shippedDate" className="field_label"><DateIcon /> Shipped Date</label>
                                <div className="field_value">
                                    <ReactDatePicker
                                        id="shippedDate"
                                        selected={shippedDate}
                                        onChange={(date) => setShippedDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="Select shipped date"
                                        className="date-picker"
                                        locale="en-GB"
                                    />
                                    <button
                                        className="btn shipmentbutton"
                                        style={{ marginLeft: "10px"}}
                                        onClick={async () => {
                                            if (!shippedDate) {
                                                toast.error("Please select a shipped date first.");
                                                return;
                                            }
                                            const formattedDate = formatPureDate(shippedDate);

                                            setIsSending(true);
                                            try {
                                                const response = await axios.post(`${config.BASE_URL}/api/v1/sendShippedEmail`, {
                                                    orderNo,
                                                    customerEmail: customer.email,
                                                    customerName: customer.customer_name,
                                                    shippedDate: formattedDate,
                                                    location: selectedLocation,
                                                });
                                                if (response.status === 200) {
                                                    toast.success("Shipped email sent successfully!");
                                                } else {
                                                    toast.error("Failed to send shipped email.");
                                                }
                                            } catch (error) {
                                                console.error(error);
                                                toast.error("Error sending shipped email.");
                                            } finally {
                                                setIsSending(false); // stop loading
                                            }
                                        }}
                                    >
                                        {isSending ? "Sending..." : "Send Email"}
                                    </button>
                                </div>
                            </div>
                        )}



                        <div class="form-group row">
                            <label for="location" class="field_label">Location</label>
                            <div class="field_value">
                                <select
                                    id="location"
                                    value={selectedLocation} // Bind to state
                                    onChange={(e) => setSelectedLocation(e.target.value)}
                                    className="form-control"
                                >
                                    <option value="" disabled>Select Location</option>
                                    <option value="Sydney CBD">Sydney CBD</option>
                                    <option value="Castle Hill">Castle Hill</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="add_product_btn">
                    <button className="add-product-btn btn" onClick={handleAddProductClick}  > Add Product </button>
                    {/* {productsInOrder?.map((product, index) => (
                        <div key={index} className="product-card">
                            <h3>{product.name}</h3>
                            <div className="product-details">
                                <div>
                                    <button>Add Style</button>
                                    <button>Measurements</button>
                                    <button>Add Images</button>
                                </div>
                                <div>
                                    <p><strong>Quantity:</strong> {product.quantity}</p>
                                    <p><strong>Fabric:</strong> {product.fabric}</p>
                                    <p><strong>Lining:</strong> {product.lining}</p>
                                    <p><strong>Groomsman:</strong> {product.groomsman ? "Yes" : "No"}</p>
                                    <p><strong>Price:</strong> {product.price}</p>
                                    <p><strong>Remarks:</strong> {product.remarks}</p>
                                </div>
                            </div>
                            <div className="product-actions">
                                <button>Edit</button>
                                <button>Delete</button>
                                <button>Duplicate Style</button>
                            </div>
                        </div>
                    ))} */}
                </div>


                <div className="layout_outer_shadow_grid">
                    {loadingCustomer || loadingProducts ? (
                        <ClipLoader color="#123abc" size={80} />
                    ) : (


                        displayProducts.map((product) => (

                            <div className="product_edit layout_outer_shadow">
                                <div className="product_edit_item">
                                    <h4 className="product_client_name">{product.description} - {product.customerName ||customer?.customer_name}</h4>
                                    <div className="add_style">
                                        {product.description !== "Accessories" && (<button
                                            className="add-product-btn btn"
                                            onClick={() => handleStyleModalOpen(product.description, product._id,product?.customerInfo?._id || product?.customer_id )}
                                        >
                                            Add Style </button>)}
                                        
                                    </div>
                                      {product.description !== "Accessories" &&  <div className="measurements">
                                        <button className="add-product-btn btn" onClick={() => handleMeasurementModalOpen(product)} > Measurements </button>
                                    </div>}
                                   

                                    <div className="add_image">
                                        <button className="btn " onClick={() => handleButtonClick(product._id)}>Add Image
                                        </button>
                                        <input
                                            ref={(el) => (fileInputRefs.current[product._id] = el)}
                                            type="file"
                                            accept="image/*"
                                            multiple
                                            style={{ display: "none" }}
                                            productId={product._id}
                                            onChange={(e) => handleImageChange(e, product._id)}
                                        />
                                        {uploadProgress !== null && (
                                            <div className="progress-bar">
                                                <div
                                                    className="progress"
                                                    style={{ width: `${uploadProgress}%` }}
                                                />
                                            </div>
                                        )}

                                        {product?.images?.length > 0 && (
                                            <div className="uploaded-images">
                                                <div className="image-previews">
                                                    {product?.images.map((imageUrl, index) => {
                                                        // Handle object with imagePath
                                                        const url =
                                                            typeof imageUrl === "object"
                                                                ? imageUrl?.imagePath
                                                                : imageUrl;

                                                        // If it's a Firebase URL, use it directly; else prefix with BASE_URL
                                                        const finalUrl = url?.startsWith("https://firebasestorage")
                                                            ? url
                                                            : `${config.BASE_URL}/${url}`;

                                                        return (
                                                            <div key={index} className="added_images">
                                                                <span
                                                                    className="clos_btn"
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        userSelect: "none",     
                                                                    }}
                                                                    onClick={() =>
                    
                                                                        handleRemoveImage(url, index, product.parentSuitId || product._id)
                                                                    }
                                                                >
                                                                    -
                                                                </span>
                                                                <img
                                                                    src={finalUrl}
                                                                    alt={`Uploaded ${index}`}
                                                                    width="100"
                                                                     style={{width:"100%", height:"100%" , objectFit:"cover"}}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                                <div className="product_edit_item">
                                    <div className="form-group row">
                                        <label for="qty" className="field_label">Quantity</label>
                                        <div className="field_value">{product.quantity}</div>
                                    </div>
                                    <div className="form-group row">
                                        <label for="fabric" className="field_label">Fabric</label>
                                        <div className="field_value">{product.fabric}</div>
                                    </div>
                                    <div className="form-group row">
                                        <label for="lining" className="field_label">Lining</label>
                                        <div className="field_value">{product.lining}</div>
                                    </div>
                                </div>
                                <div className="product_edit_item">
                                    <div className="product_edit_remove_btns">
                                        <button
                                            className="edit_details"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleEditProduct(product);
                                            }}
                                        >
                                            <EditIcon />
                                        </button>
                                        <button className="remove_product" onClick={() => handleDeleteProduct(product._id)}>
                                            <DeleteIcon />
                                        </button>
                                    </div>
                                    <div className="m-b-20">
                                        <label for="remarks">Remarks</label>
                                        <textarea
                                            id="remarks"
                                            className="form-control"
                                            readOnly
                                            value={product.remarks || ""}
                                        />

                                    </div>
                                    {/* <div className="row">
                                    <div className=""><button className="btn" onClick={() => handleDuplicateStyleOpen(product._id)}>Duplicate Style</button></div>

                                </div> */}
                                </div>
                            </div>

                        ))
                    )}
                </div>

                <AddProductModal
                    isModalOpen={isModalOpen}
                    newProduct={newProduct}
                    setNewProduct={setNewProduct}
                    handleSaveProduct={handleSaveProduct}
                    quote_id={quote_id}
                    handleModalClose={handleModalClose}
                    quoteNo={quoteNo}
                    setIsQuoteCreated={setIsQuoteCreated}
                    isQuoteCreated={isQuoteCreated}
                    productOptions={productOptions}
                    addOrderForSuit={true}
                    customerId={customerId}
                    customer_name={customer?.customer_name}
                    isOrder={true}
                />


                <AddStyleModal
                    styleModalOpen={styleModalOpen}
                    handleStyleModalClose={handleStyleModalClose}
                    selectedStyle={selectedStyle}
                    productsInOrder={productsInOrder}
                    customerId={currentCustomerId}
                    products={products}
                    onMeasurementsUpdated={fetchProducts}
                />

                <MeasurementModal
                    measurementModalOpen={measurementModalOpen}
                    setNewProduct={setNewProduct}
                    handleMeasurementModalClose={handleMeasurementModalClose}
                    selectedStyle={selectedStyle}
                    productsInOrder={productsInOrder}
                    customerId={customerId}
                    products={products}
                    onMeasurementsUpdated={fetchProducts}
                />

                <div className="new_order_bottom_btns">
                    <button className="btn">Customer List</button>
                    <button className="btn" onClick={handleSaveOrder} disabled={buttonLoading}>Save Order</button>
                    {/* <button className="btn">Preview</button> */}
                </div>
            </div>
        </Layout>
    );
};

export default OrderPage;
